<app-page-template
  [showParent]="showParent"
  (clearQueryString)="onClearQueryString()"
  [class]="pageConfig.isVisibleHelpPage ? 'd-none' : ''"
  [config]="pageConfig"
  (onAdd)="onCreate()"
  (sortObject)="getSortItems($event)"
  (onShowAuditPage)="onShowAuditPage()"
  (onShowHelpPage)="onShowHelpPage()"
  (onSelectAll)="onSelectAll($event)"
  (comparisonObjects)="getComparisonObjects($event)"
  (pageNumber)="changePageNumber($event)"
  (pageSize)="changePageSize($event)"
>
  <!--------------------------------------------------------------- Table Content ---------------->
  <ng-container table-body *ngIf="(items$ | async) && !pageConfig.loading">
    <ng-container *ngFor="let item of items$ | async; let i = index">
      <tr
        #row
        (click)="onActiveRow(row, i)"
        [class.row-active]="rowIndexSelected == i"
      >
        <!-- index -->
        <td class="tw-text-center !tw-px-4 !tw-py-2">
          {{ paginationModel?.firstIndex + i }}
        </td>

        <!-- province -->
        <td>
          <td-value
            class="font-vazir-ui"
            copyToClipboard
            [value]="item?.province"
          ></td-value>
        </td>

        <!-- city -->
        <td>
          <td-value
            class="font-vazir-ui"
            copyToClipboard
            [value]="item?.city"
          ></td-value>
        </td>

        <!--operatorClasses-->
        <td>
          <app-expand-item
            *ngIf="item?.operatorClasses?.length > 1"
            [isCustom]="true"
            [placement]="'right'"
          >
            <ul class="custom dir-rtl tw-mb-0">
              <li *ngFor="let item of item?.operatorClasses" class="tw-mb-1">
                {{ item?.operator | enumToText : SmsAggregatorEnumValues }}:
                {{ item.class }}
              </li>
            </ul>
          </app-expand-item>

          <td-value
            *ngIf="item?.operatorClasses?.length < 2"
            copyToClipboard
            type="number"
            [value]="item?.operatorClasses[0].class"
          >
          </td-value>
        </td>

        <!------------------------------- operations -------------------------------->

        <td class="sticky-td">
          <div
            app-menu-btn
            [matMenuTriggerFor]="menu"
            [isShowDotsMenu]="true"
          ></div>

          <mat-menu #menu="matMenu" xPosition="before">
            <!-- *edit btn -->
            <div app-menu-btn icon="edit" (click)="onUpdate(item.id)"></div>
          </mat-menu>
        </td>
      </tr>
    </ng-container>
  </ng-container>
</app-page-template>

<!-- form -->
<ng-container *ngIf="pageConfig?.isVisibleForm">
  <app-smart-sms-number-classes-form
    (closePage)="pageConfig.isVisibleForm = false"
    (closeFormPage)="getFormResponse($event)"
  >
  </app-smart-sms-number-classes-form>
</ng-container>

<!--------------------------------------------------------------- help ---------------->
<ng-container *ngIf="pageConfig?.isVisibleHelpPage">
  <app-help-page
    [menuTitle]="pageName"
    (hidePage)="onHideHelpPage()"
    [title]="pageConfig.title"
  >
  </app-help-page>
</ng-container>
